import React from 'react';
import { motion } from 'framer-motion';
import { Target, TrendingUp, Users } from 'lucide-react';

const impacts = [
  {
    icon: Target,
    value: '50+',
    label: 'Research Projects',
    description: 'Active research initiatives across Africa'
  },
  {
    icon: TrendingUp,
    value: '25+',
    label: 'Publications',
    description: 'Peer-reviewed articles and policy papers'
  },
  {
    icon: Users,
    value: '1000+',
    label: 'Citations',
    description: 'Research impact in academic literature'
  }
];

export default function ResearchImpact() {
  return (
    <section className="py-20 bg-gradient-to-br from-green-900 to-emerald-900 relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80')] opacity-10" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl font-bold text-white">Research Impact</h2>
          <p className="mt-4 text-xl text-green-100">
            Making a difference through evidence-based research
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {impacts.map((impact, index) => {
            const Icon = impact.icon;
            return (
              <motion.div
                key={impact.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="text-center"
              >
                <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20">
                  <Icon className="h-8 w-8 text-green-300 mx-auto mb-4" />
                  <div className="text-4xl font-bold text-white mb-2">{impact.value}</div>
                  <div className="text-xl font-semibold text-green-300 mb-2">{impact.label}</div>
                  <p className="text-green-100">{impact.description}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}